import React from 'react';
import { Section } from './Section';
import { Instagram as InstagramIcon } from 'lucide-react';
export function Instagram() {
  return <Section data-id="element-69">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8 bg-gradient-to-r from-surface to-surfaceHover p-8 md:p-12 rounded-3xl border border-white/5" data-id="element-70">
        <div data-id="element-71">
          <h2 className="text-2xl md:text-4xl font-serif mb-3" data-id="element-72">
            Seguinos también en Instagram
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-73">
            Backstage, adelantos y clips cortos.{' '}
            <span className="text-amber-400" data-id="element-74">@pampanation</span>
          </p>
        </div>

        <a href="https://www.instagram.com/pampanation" target="_blank" rel="noopener noreferrer" className="shrink-0 flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-8 py-4 rounded-full transition-colors duration-300" data-id="element-75">
          <InstagramIcon className="w-5 h-5" data-id="element-76" />
          Ver Instagram
        </a>
      </div>
    </Section>;
}